import { LabelLessInput } from "components/Input";
import { toNumberWithFallback } from "features/shared/lib/formatters";

import { TRANSIENT_INPUT_HEIGHT } from "../lib/transientForm";
import { ScenarioFieldRow } from "./ScenarioFieldRow";

type TransientNumericFieldRowProps = {
  alignControlEnd?: boolean;
  disabled?: boolean;
  label: string;
  labelClassName?: string;
  onChange: (value: number) => void;
  step?: string;
  value: number;
};

export const TransientNumericFieldRow = ({
  alignControlEnd = false,
  disabled = false,
  label,
  labelClassName,
  onChange,
  step,
  value,
}: TransientNumericFieldRowProps) => {
  return (
    <ScenarioFieldRow alignControlEnd={alignControlEnd} label={label} labelClassName={labelClassName}>
      <LabelLessInput
        className="w-full"
        disabled={disabled}
        height={TRANSIENT_INPUT_HEIGHT}
        onChange={(event) => onChange(toNumberWithFallback(event.target.value, value))}
        step={step}
        type="number"
        value={value}
      />
    </ScenarioFieldRow>
  );
};
